import { APP_BASE } from '@/config/appBase'

export default (path) => {
  if (path.substring(0, 1) === '/') {
    path = path.substring(1)
  }

  const base = APP_BASE
  if (base !== '/') {
    return APP_BASE + '/' + path
  } else {
    return '/' + path
  }
}
